import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import DesignHubRepository from "src/repository/DesignHubRepository";
import { __remove, __set } from "src/store/axios_indicator";

export const getCountryList = createAsyncThunk('get_country_list', async () => {
    return await new DesignHubRepository().getCountryList()
});

export const getCrossReferencePart = createAsyncThunk('get_cross_reference_part', async (params) => {
    __set('CROSS_REFERENCE_SEARCH_PART_API_CALL')
    return await new DesignHubRepository().getCrossReferencePart(params);
})

const slice = createSlice({
    name: "DesignHub",
    initialState: {
       countryList: {},
       crossReferenceParts: {}
    },
    reducers: {
 
    },
    extraReducers: {
        [getCountryList.fulfilled]: (state, { payload }) => {
            state.countryList = payload;
        },
        [getCrossReferencePart.fulfilled]: (state, { payload }) => {
            __remove('CROSS_REFERENCE_SEARCH_PART_API_CALL')
            state.crossReferenceParts = payload;
        },
        [getCrossReferencePart.rejected]: (state, { payload }) => {
            state.crossReferenceParts = [];
            __remove('CROSS_REFERENCE_SEARCH_PART_API_CALL')
        }
    },
});



export let {  } = slice.actions;

export default slice.reducer;
